import styled from 'styled-components';

const SettingsGrid = styled.div`
  display: grid;
  grid-template-rows: repeat(12, auto);
  grid-auto-flow: column;
  gap: 1rem;
  height: auto;
`;

export default SettingsGrid;
